export const footerLinks: string[] = [
  "About",
  "Join",
  "Projects",
  // "Education",
  "Work With Us",
];

// This is dumb, it should be fixed, but I'm lazy and tired
export const lowercaseFooterLinks: string[] = [
  "about",
  "join",
  "projects",
  // "education",
  "workwithus",
];
